(function () {
  // Vimeo Click-to-Play Facade (Privacy-Friendly)
  // This prevents third-party cookies until user interaction
  function initVimeoFacade() {
    // Handle hero background videos
    document
      .querySelectorAll(".hero-block__video-facade")
      .forEach(function (facade) {
        const playButton = facade.querySelector(".hero-block__video-play");
        if (!playButton) return;

        playButton.addEventListener("click", function () {
          const videoSrc = facade.getAttribute("data-video-src");
          if (!videoSrc) return;

          // Create and inject iframe
          const iframe = document.createElement("iframe");
          iframe.setAttribute("src", videoSrc);
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute(
            "allow",
            "autoplay; fullscreen; picture-in-picture",
          );
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("title", "Background video");
          iframe.style.cssText =
            "position:absolute;top:0;left:0;width:100%;height:100%;";

          // Remove facade class and play button
          facade.classList.remove("hero-block__video-facade");
          playButton.remove();

          // Add iframe
          facade.appendChild(iframe);

          // Resize the iframe to cover
          setTimeout(function () {
            resizeHeroIframe(facade.closest(".hero-block"));
          }, 100);
        });
      });

    // Handle content-split videos
    document
      .querySelectorAll(".content-split__video-facade")
      .forEach(function (facade) {
        const playButton = facade.querySelector(".content-split__video-play");
        if (!playButton) return;

        playButton.addEventListener("click", function () {
          const videoSrc = facade.getAttribute("data-video-src");
          const videoId = facade.getAttribute("data-video-id");
          if (!videoSrc) return;

          // Create and inject iframe
          const iframe = document.createElement("iframe");
          iframe.className = "content-split__iframe";
          iframe.setAttribute("src", videoSrc);
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute(
            "allow",
            "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share",
          );
          iframe.setAttribute(
            "referrerpolicy",
            "strict-origin-when-cross-origin",
          );
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("title", "Video content");
          iframe.setAttribute("width", "640");
          iframe.setAttribute("height", "360");
          iframe.style.cssText =
            "position:absolute;top:0;left:0;width:100%;height:100%;";

          // Remove facade class and play button
          facade.classList.remove("content-split__video-facade");
          playButton.remove();

          // Add iframe
          facade.appendChild(iframe);
        });
      });
  }

  // Resize the Vimeo background iframe so it always "covers" the hero container.
  function resizeHeroIframe(container) {
    var wrap = container.querySelector(".hero-block__video-wrap");
    if (!wrap) return;
    var iframe = wrap.querySelector("iframe");
    if (!iframe) return;

    var rect = wrap.getBoundingClientRect();
    var cw = rect.width;
    var ch = rect.height;
    var aspect = 16 / 9;

    // Calculate dimensions that will cover the container while preserving aspect ratio
    var requiredWidth = Math.max(cw, ch * aspect);
    var requiredHeight = Math.max(ch, cw / aspect);

    // Apply size and keep it centered via transform
    iframe.style.width = requiredWidth + "px";
    iframe.style.height = requiredHeight + "px";
    iframe.style.top = "50%";
    iframe.style.left = "50%";
    iframe.style.transform = "translate(-50%, -50%)";
    iframe.style.position = "absolute";
  }

  function initAll() {
    // Initialize click-to-play facades
    initVimeoFacade();

    // Set up resize handlers for any loaded videos
    var blocks = document.querySelectorAll(".hero-block.has-background-video");
    blocks.forEach(function (block) {
      // run once now
      resizeHeroIframe(block);
      // update on resize
      window.addEventListener("resize", function () {
        resizeHeroIframe(block);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-toggle").forEach(function (toggle) {
    const content = toggle.nextElementSibling;
    const accordionItem = toggle.closest(".accordion-item");

    if (!content || !content.classList.contains("accordion-content")) {
      return;
    }

    // Initialize: remove hidden attribute but keep height at 0
    if (content.hasAttribute("hidden")) {
      content.removeAttribute("hidden");
    }
    content.style.height = "0";
    content.setAttribute("aria-hidden", "true");

    toggle.addEventListener("click", function () {
      const expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", !expanded);

      if (!expanded) {
        // Expanding
        if (accordionItem) {
          accordionItem.classList.add("open");
        }
        content.setAttribute("aria-hidden", "false");
        // Need to get scrollHeight after setting aria-hidden for accurate measurement
        requestAnimationFrame(function () {
          content.style.height = content.scrollHeight + "px";
        });
      } else {
        // Collapsing: first set to current height, then to 0
        if (accordionItem) {
          accordionItem.classList.remove("open");
        }
        content.style.height = content.scrollHeight + "px";

        requestAnimationFrame(function () {
          content.style.height = "0";
          content.setAttribute("aria-hidden", "true");
        });
      }
    });
  });
});

jQuery(document).ready(function($){

    var $header = $('.main-header');
    var scrollTrigger = 200;

    $(window).on('scroll', function () {

        if ($(window).scrollTop() > scrollTrigger) {
            $header.addClass('shrink');
        } else {
            $header.removeClass('shrink');
        }

    });

    $('.hardware-tabs-expand').each(function(){

        const $section = $(this);
        const $wrapper = $section.find('.tabs-wrapper');

        function updateImageVisibility($activeTab) {
            const hasImage = $activeTab.data('has-image') == 1;
            $wrapper.toggleClass('no-images', !hasImage);
        }

        // Set correct state for the initially active tab
        updateImageVisibility($section.find('.tab-item.active'));

        $section.find('.tab-item').on('click', function (e) {
            if ($(e.target).closest('a').length) {
                return;
            }

            var $item = $(this);
            var index = $item.data('index');
            var isMobile = $(window).width() < 768;

            // On mobile the open header stays visible and is the close control.
            // Desktop hides that header and closes a tab by opening another one.
            if (isMobile && $item.hasClass('active') && $(e.target).closest('.tab-head').length) {
                $item.removeClass('active');
                $section.find('.tab-image').removeClass('active');
                $wrapper.removeClass('no-images');
                return;
            }

            if ($item.hasClass('active')) {
                return;
            }

            $section.find('.tab-item').removeClass('active');
            $item.addClass('active');

            $section.find('.tab-image').removeClass('active');
            $section.find('.tab-image[data-index="' + index + '"]').addClass('active');

            updateImageVisibility($item);
        });

    });

});

jQuery(document).ready(function ($) {

    $('.faq-section').each(function () {

        var $section = $(this);

        // Hide all answers inside this section
        $section.find('.faq-answer').hide();

        // Show active one
        $section.find('.faq-item.active .faq-answer').show();

        // Click inside THIS section only
        $section.on('click', '.faq-question', function () {

            var $item = $(this).closest('.faq-item');

            if ($item.hasClass('active')) {

                $item.removeClass('active')
                     .find('.faq-answer')
                     .slideUp(300);

            } else {

                $item.addClass('active')
                     .siblings('.faq-item')
                     .removeClass('active')
                     .find('.faq-answer')
                     .slideUp(300);

                $item.find('.faq-answer').slideDown(300);
            }

        });

    });
    
});

jQuery(document).ready(function($) {

  $(document).on('click', '.qty-btn.plus', function() {
    var $wrapper = $(this).closest('.product-meta');
    var $input = $wrapper.find('.quantity input.qty');

    var val = parseFloat($input.val()) || 0;
    var step = parseFloat($input.attr('step')) || 1;
    var max = parseFloat($input.attr('max'));

    if (!max || val < max) {
      $input.val(val + step).trigger('change');
    }
  });

  $(document).on('click', '.qty-btn.minus', function() {
    var $wrapper = $(this).closest('.product-meta');
    var $input = $wrapper.find('.quantity input.qty');

    var val = parseFloat($input.val()) || 0;
    var step = parseFloat($input.attr('step')) || 1;
    var min = parseFloat($input.attr('min')) || 1;

    if (val > min) {
      $input.val(val - step).trigger('change');
    }
  });

});

jQuery(document).ready(function ($) {

    var $menu = $('.product-category-nav .menu');
    var $toggle = $('.cat-toggle');
    var $menuItems = $('.product-category-nav .menu > li');

    $menuItems.each(function () {
        if ($(this).find('.sub-menu').length) {
            $(this).prepend('<span class="submenu-toggle"></span>');
        }
    });

    // ✅ 1. Set first LI text on load
    // var firstText = $menu.find('> li:first-child > a').text();
    // $toggle.text(firstText);

    // ✅ 2. On click menu item → update toggle text
    $menu.on('click', 'li > a', function (e) {
        var text = $(this).text();
        $toggle.text(text);
        $toggle.removeClass('active');
    });

    // ✅ 3. Toggle menu (mobile)
    $toggle.on('click', function () {
        $(this).toggleClass('active');
        $menu.slideToggle();
    });

    $('.product-category-nav').on('click', '.submenu-toggle', function (e) {
        e.preventDefault();

        var $parentLi = $(this).closest('li');

        // Accordion behavior (optional)
        $parentLi.siblings().removeClass('active')
            .find('.sub-menu').slideUp();

        // Toggle current
        $parentLi.toggleClass('active');
        $parentLi.find('.sub-menu').first().slideToggle();
    });

});

jQuery(document).ready(function ($) {

    function getYouTubeID(url) {
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
        let match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    }

    $(document).on('click', '.video-slide', function () {

        let type = $(this).attr('data-type');
        let src  = $(this).attr('data-src');

        console.log(type, src); // 👉 DEBUG (check in console)

        if (!type || !src) {
            console.warn('Missing data-type or data-src');
            return;
        }

        let videoHTML = '';

        // ▶ YouTube
        if (type === 'youtube') {
            let videoID = getYouTubeID(src);

            if (!videoID) {
                console.warn('Invalid YouTube URL');
                return;
            }

            videoHTML = `<iframe 
                width="100%" 
                height="450" 
                src="https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0" 
                frameborder="0" 
                allow="autoplay; encrypted-media" 
                allowfullscreen>
            </iframe>`;
        }

        // ▶ Self video
        if (type === 'video') {
            videoHTML = `<video controls autoplay width="100%">
                <source src="${src}" type="video/mp4">
            </video>`;
        }

        $('.video-container').html(videoHTML);
        $('.video-popup').addClass('active');
    });

    // Close popup
    $(document).on('click', '.video-popup-close, .video-popup-overlay', function () {
        $('.video-popup').removeClass('active');
        $('.video-container').html('');
    });

});

jQuery(function ($) {

    $(document).on('click', '.product-category-nav .cat-toggle', function (e) {
        e.preventDefault();

        $('.product-category-nav').toggleClass('active');
        $('body').toggleClass('overflow');
    });

    function resetCategoryNav() {
        if ($(window).width() > 767) {
            $('.product-category-nav').removeClass('active');
            $('body').removeClass('overflow');
        }
    }

    // Run on page load
    resetCategoryNav();

    // Run on window resize
    $(window).on('resize', resetCategoryNav);

});